import clsx from "clsx";

export function Skeleton({ className = "" }) {
  return (
    <div className="w-full animate-pulse">
      <div
        className={clsx("rounded-full bg-gray-200 dark:bg-gray-800", className)}
      ></div>
    </div>
  );
}
